import * as React from "react";
import MultiSelectModal, { GetQueryFilter } from "../../misc/components/queryTable/MultiSelectModal";
import { QueryCondition, Query, Subject, QueryFilter } from "../../misc/api/apiTypes";
import { SubjectRandomizationNumberFilterMember, SubjectRandomizationStatusFilterMember } from "../SubjectsShared";
import { orderBy, uniqBy } from "lodash";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface RandomizationTableFilterProps {
    query: Query<Subject>;
    onClose: (filters: QueryFilter[]) => void;
    onClear: (member: string) => void;
}

const GetQueryFilter_ = (query: Query<any>): any[] => {
    var numberValues = [];
    var statusValues = [];
    
    var qf = GetQueryFilter(query, SubjectRandomizationNumberFilterMember, QueryCondition.Equal);
    numberValues = qf ? qf.Values : [];
    qf = GetQueryFilter(query, SubjectRandomizationStatusFilterMember, QueryCondition.Equal);
    statusValues = qf ? qf.Values : [];

    var result = numberValues.concat(statusValues.map(sv => sv ? "Yes" : "No"));
    
    return result;
}

const CreateOptions = (data: Subject[]) => {
    var options = [];
    var uniqueOrdered = orderBy(uniqBy(data, SubjectRandomizationNumberFilterMember), SubjectRandomizationNumberFilterMember);
    uniqueOrdered = uniqueOrdered.filter(d => d.RandomisedStatus === true);
    const exactSelections = uniqueOrdered.map(r => ({ label: r.RandomisedId, value: r.RandomisedId }));
    options.push(...exactSelections);
    if(data.some(e=>!e.RandomisedId))
        options.push({ label: "-", value: "No" });
    
    return options;
}

const CreateQueryFilter_ = (values: string[]) => {
    if (!values)
        return [];

    const queries = [];
    var yesNoSelections = [];
    if (values.find(v => v === "Yes"))
        yesNoSelections.push(true);
    if (values.find(v => v === "No"))
        yesNoSelections.push(false);

    queries.push({ Member: SubjectRandomizationStatusFilterMember, Condition: QueryCondition.Equal, Values: yesNoSelections });

    var fixedValues = values.filter(v => v !== "Yes" && v !== "No"); 
    queries.push({ Member: SubjectRandomizationNumberFilterMember, Condition: QueryCondition.Equal, Values: fixedValues });
    
    return queries;
}

export const RandomizationTableFilter = ({ query, onClose, onClear, }: RandomizationTableFilterProps): JSX.Element => {
    const queryFilterValues = GetQueryFilter_(query);
    const [values, setValues] = React.useState<string[]>(queryFilterValues);
    const [allStatus, setAllStatus] = React.useState<any[]>([]);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getSubjects({}).then(result => {
            setAllStatus(CreateOptions(result.Data));
        });
    }, []);

    return (<MultiSelectModal header="Randomization Filter"
        isLoading={!allStatus}
        show={true}
        options={allStatus}
        valueKey="value"
        labelKey="label"
        values={values}
        onChange={(updatedValues) => {
            setValues(updatedValues.length > 0 ? updatedValues.map(uv => uv.value) : null);
        }}
        onClose={() => {
            onClose(CreateQueryFilter_(values));
        }}
        onClear={() => {
            onClear(SubjectRandomizationNumberFilterMember);
            onClear(SubjectRandomizationStatusFilterMember);
        }}
    />)
}
